import { createClient, SupabaseClient } from '@supabase/supabase-js'
import type { Database } from './database.types'

/**
 * Cliente Supabase singleton.
 *
 * Em modo demo (VITE_DEMO_MODE=true ou variáveis ausentes), retorna null
 * e o app cai no caminho mockado via demo-data.ts.
 */

const url = import.meta.env.VITE_SUPABASE_URL
const anonKey = import.meta.env.VITE_SUPABASE_ANON_KEY
const demoFlag = import.meta.env.VITE_DEMO_MODE

export const IS_DEMO_MODE =
  demoFlag === 'true' || !url || !anonKey || url.includes('seu-projeto')

let _client: SupabaseClient<Database> | null = null

export function getSupabase(): SupabaseClient<Database> | null {
  if (IS_DEMO_MODE) return null
  if (!_client) {
    _client = createClient<Database>(url, anonKey, {
      auth: {
        persistSession: true,
        autoRefreshToken: true,
        detectSessionInUrl: true,
      },
    })
  }
  return _client
}

/** Atalho: lança erro se chamado fora do modo Supabase real */
export function requireSupabase(): SupabaseClient<Database> {
  const c = getSupabase()
  if (!c) {
    throw new Error(
      'Supabase não configurado. Defina VITE_SUPABASE_URL e VITE_SUPABASE_ANON_KEY no .env (ou use VITE_DEMO_MODE=true).'
    )
  }
  return c
}
